module.exports = __webpack_public_path__ + "img/s.d1601f25.jpg";